import { useId, type ReactNode, type SelectHTMLAttributes } from 'react';

/** Kompakt, lekerekített szűrőválasztó (szűrősor). A címke képernyőolvasónak szól; `aktiv` jelzi, ha nem az alapértéken áll. */
export default function ChipValaszto({ label, aktiv, children, ...tobbi }:
  { label: string; aktiv: boolean; children: ReactNode } & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className'>) {
  const id = useId();
  return (
    <div className="relative">
      <label htmlFor={id} className="sr-only">{label}</label>
      <select id={id} {...tobbi}
        className={`h-10 max-w-full appearance-none rounded-full border py-0 pr-8 pl-3.5 text-[max(16px,1rem)] md:text-[13px] text-szoveg-halk hover:text-szoveg ${aktiv ? 'border-vonal-eros bg-felulet text-szoveg' : 'border-vonal bg-transparent'}`}>
        {children}
      </select>
      <span aria-hidden className="pointer-events-none absolute top-1/2 right-3 size-1.5 -translate-y-[70%] rotate-45 border-r border-b border-current text-szoveg-halk" />
    </div>
  );
}
